import { Phone, BellOff, Bell, Video } from "lucide-react";
import { getInitials, getAvatarColor } from "@/mock/data";
import { usePresenceStore } from "@/store/presenceStore";
import "./DMHeader.css";

interface DMHeaderProps {
  userId: string;
  displayName: string;
  isMuted: boolean;
  onToggleMute: () => void;
  onStartCall: () => void;
}

export function DMHeader({
  userId,
  displayName,
  isMuted,
  onToggleMute,
  onStartCall,
}: DMHeaderProps) {
  const presence = usePresenceStore((s) => s.getPresence(userId));

  return (
    <div className="dm-header">
      <div
        className="dm-header__avatar"
        style={{ background: getAvatarColor(userId) }}
      >
        {getInitials(displayName)}
        <div className={`dm-header__presence dm-header__presence--${presence}`} />
      </div>
      <span className="dm-header__name">{displayName}</span>
      <span className="dm-header__status">{presence}</span>
      <div className="dm-header__divider" />

      <div className="dm-header__actions">
        <button
          className="dm-header__btn"
          onClick={onStartCall}
          aria-label="Start call"
        >
          <Phone size={18} />
        </button>
        <button
          className="dm-header__btn"
          onClick={onStartCall}
          aria-label="Start video call"
        >
          <Video size={18} />
        </button>
        <button
          className={`dm-header__btn${isMuted ? " dm-header__btn--active" : ""}`}
          onClick={onToggleMute}
          aria-label={isMuted ? "Unmute" : "Mute"}
        >
          {isMuted ? <BellOff size={18} /> : <Bell size={18} />}
        </button>
      </div>
    </div>
  );
}
